
import React from 'react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { AlertCircle } from 'lucide-react';

interface TabsContainerProps {
  activeTab: string;
  errorCount: number; 
  onTabChange: (value: string) => void;
  children: React.ReactNode;
  hideApiKeys?: boolean;
  errorLogsOnly?: boolean;
}

const TabsContainer: React.FC<TabsContainerProps> = ({ 
  activeTab, 
  errorCount, 
  onTabChange, 
  children,
  hideApiKeys = false,
  errorLogsOnly = false
}) => {
  return (
    <Tabs 
      defaultValue={activeTab} 
      value={activeTab} 
      onValueChange={onTabChange} 
      className="w-full"
    >
      <TabsList className="grid grid-cols-1 mb-4">
        <TabsTrigger value="errors" className="flex items-center gap-2 relative">
          <AlertCircle className="h-4 w-4" />
          <span className="hidden sm:inline">Error Logs</span>
          {errorCount > 0 && (
            <span className="absolute -top-1 -right-1 flex h-4 w-4 items-center justify-center rounded-full bg-destructive text-[10px] text-destructive-foreground">
              {errorCount > 9 ? '9+' : errorCount}
            </span>
          )}
        </TabsTrigger>
      </TabsList>
      
      {children}
    </Tabs>
  );
};

export default TabsContainer;
